
export const sortAlphabetically = (a, b, property, asc = true) => {
    if (!aP || !bP || !aP.hasOwnProperty(property) || !bP.hasOwnProperty(property)){
        return 0;
    }
    const aP = asc ? a : b;
    const bP = asc ? b : a;
    return aP[property].localeCompare(bP[property]);
};

export const sortByProperty = (a, b, property, asc = true) => {
    if(a[property] < b[property]) { return asc ? -1 : 1; }
    if(a[property] > b[property]) { return asc ? 1 : -1; }

    return 0;
};
